export function rafDebounce(fn: (...args: any[]) => void) {
  let id: number
  return (...args) => {
    window.cancelAnimationFrame(id)
    id = window.requestAnimationFrame(() => fn(...args))
  }
}
